
import { defineComponent } from 'vue';
import { overlayComposition } from '@/core/modules/overlay/services';
import { useStore } from 'vuex';

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },
    
    setup() {
        const store = useStore();
        const overlays = [
            'aleviation-resolution',
        ];

        function changeScreen() {
            store.dispatch('axn_updateEhrActiveFrame', 'epic-statistical-methods');
        }

        function changeScreenTwo() {
            store.dispatch('axn_updateEhrActiveFrame', 'epic-study-endpoints');
        }

        return { changeScreen, changeScreenTwo, ...overlayComposition(), overlays }
    }
})

